// Angular modules
import { HttpModule } from '@angular/http';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { MomentModule } from 'ngx-moment';

// CoreUI theme modules
import { AppAsideModule, AppBreadcrumbModule, AppHeaderModule, AppFooterModule, AppSidebarModule} from '@coreui/angular';

// 3rd party modules
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TabsModule } from 'ngx-bootstrap/tabs';
//import { ChartsModule } from 'ng2-charts/ng2-charts';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ToastrModule } from 'ngx-toastr';
import { MqttModule, IMqttServiceOptions } from 'ngx-mqtt';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

// Kendo-UI modules
import { InputsModule } from '@progress/kendo-angular-inputs';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { GridModule } from '@progress/kendo-angular-grid';
import { DialogsModule, WindowModule } from '@progress/kendo-angular-dialog';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { PDFExportModule } from '@progress/kendo-angular-pdf-export';
import { SchedulerModule } from '@progress/kendo-angular-scheduler';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { ChartsModule} from '@progress/kendo-angular-charts';

// TrazeLab routing module
import { AppRoutingModule } from './app.routing';

// TrazeLab shared modules
import { SDKBrowserModule } from './shared/sdk/index';
import { TranslatorModule } from './shared/translate/index';
import { ComponentModule } from './shared/component/index';

// TrazeLab root components
import { NgEventBus } from 'ng-event-bus';

import { DefaultLayoutComponent } from './containers';

import { P404Component } from './views/error/404.component';
import { P500Component } from './views/error/500.component';
import { LoginComponent } from './views/login/login.component';
import { RegisterComponent } from './views/register/register.component';

import { CustomerFormComponent } from './views/system/customer/customer-form/customer-form.component';

import { AppComponent } from './app.component';

import { MosquittoConfig } from './shared/mosquitto';
import { ApiModule } from './shared/sdk/services/weldtrack'

import { LineChartComponent } from './shared/component/charts/line-chart/line-chart.component';



const APP_CONTAINERS = [
  DefaultLayoutComponent
];

// const MQTT_SERVICE_OPTIONS: IMqttServiceOptions = {
//   connectOnCreate: MosquittoConfig.isConnectOnCreate(),
//   hostname: MosquittoConfig.getHostname(),
//   port: MosquittoConfig.getPort(),
//   path: MosquittoConfig.getPath(),
//   protocol: MosquittoConfig.getProtocol(),
// };
const MQTT_SERVICE_OPTIONS: IMqttServiceOptions = {
  // connectOnCreate: MosquittoConfig.isConnectOnCreate(),
  // hostname: 'localhost',
  // port: 4200,
  // path: '/mqtt',
  // protocol: 'ws',
  url: 'wss://predikt-ai.thingtrack.com/mqtt' // Puedes usar esta URL si prefieres
};

@NgModule({
  imports: [
    BrowserModule,
    AppRoutingModule,
    AppAsideModule,
    AppBreadcrumbModule.forRoot(),
    AppFooterModule,
    AppHeaderModule,
    AppSidebarModule,
    PerfectScrollbarModule,
    SDKBrowserModule.forRoot(),
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    //ChartsModule,
    BrowserAnimationsModule,
    InputsModule,
    ButtonsModule,
    DateInputsModule,
    DropDownsModule,
    GridModule,
    DialogsModule,
    WindowModule, 
    // tslint:disable-next-line: deprecation
    HttpModule,
    NgxSpinnerModule,
    ToastrModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    TooltipModule,
    PDFExportModule,
    TranslatorModule,
    ComponentModule,
    SchedulerModule,
    MomentModule,
    MqttModule.forRoot(MQTT_SERVICE_OPTIONS),
    LayoutModule,
    ChartsModule,
    ApiModule,
    
    
  ],
  declarations: [
    AppComponent,
    ...APP_CONTAINERS,
    P404Component,
    P500Component,
    LoginComponent,
    RegisterComponent,
    CustomerFormComponent,    
    LineChartComponent
    
  
  ],
  providers: [
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    NgEventBus
  ],
  entryComponents: [
    CustomerFormComponent,

  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA ],
  bootstrap: [ AppComponent ]
})
export class AppModule { }
